module.exports = __webpack_public_path__ + "static/img/img13.0d0b70a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/course/img13.jpg
// module id = D4gi
// module chunks = 1